import { SpriteMode } from "./sprite";
import { SPRITES } from '../sprites';
import { getCoords, WIDTH, HEIGHT, forEachCell, setCell} from "../utils";


const letterDuration = 2500;
const tickLength = 100;

class LetterInternalMode extends SpriteMode {
  constructor({letter, addBeatListener}) {
    super({
      sprite: SPRITES.letter[letter]
    });
    this.fraction = 1;
    this.letter = letter;

    this.time = 0;
    this.progress = 0;

    addBeatListener((beat) => {
      const rnd1 = Math.random();
      if (rnd1 < 0.8 || beat.major) {
        const offsetX = beat.major ? 2 : Math.round(Math.random() * 2) - 1;
        this.chunk = {
          x:  0,
          y: Math.ceil(Math.random() * 10)+3,
          width:  15,
          height: Math.ceil(Math.random() * 5),
          offsetX: offsetX,
          offsetY: 0,
          time: 0
        };
      }
    });
  }
  update(delta) {

    if (delta) {
  
      let tick = false;
      this.time += delta;
      if (this.time > tickLength) {
        tick = true;
        this.time = this.time % tickLength;
        this.progress += 1;
      }

      if (this.chunk) {
        this.chunk.time += delta;
        if (this.chunk.time > 100) {
          this.chunk = null;
        }
      }

        
    }
  }
  getData() {
    const data = [ ... this.sprite ];
    data.forEach((d, i) => {
      const { x, y } = getCoords(i);
      const withinFraction = (y < this.progress && y < this.fraction * HEIGHT);
      let value = false;
      if (d && withinFraction) {
        value = 'orange';
      }
      data[i] = value;
    });


    if (this.chunk) {
      const chunk = this.chunk;
      const chunkData = [];
      data.forEach((d, i) => {
        const {x, y} = getCoords(i);
        if ((x >= chunk.x && x <= chunk.x + chunk.width) && (y >= chunk.y && y <= chunk.y + chunk.height)) {
          chunkData.push({x,y,d});
          setCell(data, x, y, false);
        }
      });
      chunkData.forEach(({x, y, d}) => {
        setCell(data, x + chunk.offsetX, y + chunk.offsetY, d, { dropOutside: true });
      })
  
    }

    return data;
  }
}


export class LetterMode {
  constructor({addInteractionListener, addBeatListener}) {
    const letters = `#csvrs`.split('');

    this.mode = null;
    this.addInteractionListener = addInteractionListener;
    this.addBeatListener = addBeatListener;

    this.switchTo(LetterInternalMode, letters[0]);
    letters.forEach((l, i) => {
      if (i > 0) {
        setTimeout(() => {
          this.switchTo(LetterInternalMode, l);
        }, i * letterDuration)
      }
    });
    

  }
  switchTo(newMode, letter) {
    if (newMode) {
      this.mode = new newMode({
        ... this,
        letter
      });
    } else {
      this.mode = null;
    }
  }
  clear() { 
    this.switchTo(null);
  }
  update(delta, data) {
    this.mode?.update(delta, data);
  }
  getData() {
    return this.mode?.getData();
  }
}